import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
} from "@material-ui/core";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import styles from "./styles";
import TextField from "../../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField";
import constants from "./constants";
import PanelAction from "./Action";
import CustomerList from "./CustomerList";
import CloseIcon from "@material-ui/icons/Close";
import { getInitialNote } from "./utils";

const ShipmentNote = (props) => {
  const initialNote = getInitialNote(props.params);
  const [notes, setNotes] = useState(initialNote);
  const [notesCount, setNotesCount] = useState(initialNote.length);

  const updateNotes = (notes) => {
    setNotes(notes);
    setNotesCount(notes.length);
  };

  const { classes } = props;
  return (
    <Dialog
      aria-labelledby="proNotes"
      open={true}
      classes={{ paper: classes.dialog }}
      className={classes.dialogWrapper}
    >
      <DialogTitle
        disableTypography
        handleClose={props.handleClose}
        id="proNotes-title"
        classes={{ root: classes.dialogTitle }}
      >
        <Grid xs={3}>
          <span className={classes.dialogTitleText}>
            Shipment Note
          </span>
        </Grid>
        <Grid xs={1} className={classes.closeButton}>
          <IconButton aria-label="close" onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent className={`${classes.dialogContent} customScroll`}>
        <CustomerList customerList={props.customerList}/>
        <TextField
          id="proNotes"
          handleChange={updateNotes}
          value={notes}
          className={classes.fullWidth}
          multiline
          rows={8}
          label="Type instructions here..."
          inputProps={{
            maxLength: constants.MAX_LENGTH_CONSTRAINTS.ADD_PRO_NOTES.COMMENT,
          }}
          InputPropsClasses={{
            input: classes.inputField,
            notchedOutline: classes.notchedOutline,
          }}
          helperText={`${notesCount ?? 0}/${
            constants.MAX_LENGTH_CONSTRAINTS.ADD_PRO_NOTES.COMMENT
          }`}
          classes={{ root: classes.root }}
        />
        <PanelAction
          handleClose={props.handleClose}
          closeButtonText="Cancel"
          confirmButtonText="Save"
          isDisabled={!notes.trim()}
          handleSubmit={() =>
            props.handleSubmit({
              ...props.params,
              value: notes,
              oldValue: props.params.data?.shipmentComments,
            })
          }
        />
      </DialogContent>
    </Dialog>
  );
};

export default compose(withSnackbar, withStyles(styles))(ShipmentNote);
